import { Download } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const DownloadIcon = DeckardIconWrapper({ Icon: Download });
